import { ChangeEvent, useEffect, useState } from "react";
import { ThemeProvider } from "@material-ui/styles";
import { defaultMaterialTheme } from "../../shared/Style/Style";
import { useDebounce } from "../../shared/Utils/OtherOperations/useDebounce";
import {
  SEARCH_DEBOUNCE_MS,
  SEARCH_LABEL,
  SEARCH_MIN_CHARS,
} from "./constants";
import { ReportSearchInput } from "./styles";

interface ReportSearchProps {
  /** The key currently applied to the report; null = no search. */
  searchKey: string | null;
  onChange: (searchKey: string | null) => void;
}

// Same behaviour as Schools/SearchBar (debounce, minimum length, empty clears) minus the URL query
// param — this tab keeps its filters in component state only.
export const ReportSearch = ({ searchKey, onChange }: ReportSearchProps) => {
  const [term, setTerm] = useState(searchKey ?? "");
  const debouncedTerm = useDebounce(term.trim(), SEARCH_DEBOUNCE_MS);

  useEffect(() => {
    const next =
      debouncedTerm.length >= SEARCH_MIN_CHARS ? debouncedTerm : null;

    if (next !== searchKey) {
      onChange(next);
    }
  }, [debouncedTerm, searchKey, onChange]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
    setTerm(event.target.value);

  return (
    <ThemeProvider theme={defaultMaterialTheme}>
      <ReportSearchInput
        label={SEARCH_LABEL}
        value={term}
        onChange={handleChange}
      />
    </ThemeProvider>
  );
};
